/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */
var getClientLocalTimezone = require('../../vendors/jstz.js');
var javaEnabled = navigator.javaEnabled();
var language = navigator.language;
var colorDepth = screen.colorDepth;
var browserScreenWidth = screen.width;
var browserScreenHeight = screen.height;
var timezone = getClientLocalTimezone();

var browserData = {};
if (javaEnabled !== undefined) {
    browserData.javaEnabled = javaEnabled;
}
if (language !== undefined) {
    browserData.language = language;
}
if (colorDepth !== undefined) {
    browserData.colorDepth = colorDepth;
}
if (browserScreenWidth !== undefined) {
    browserData.browserScreenWidth = browserScreenWidth;
}
if (browserScreenHeight !== undefined) {
    browserData.browserScreenHeight = browserScreenHeight;
}
if (timezone !== undefined) {
    browserData.timezone = timezone;
}
module.exports = browserData;
